import { render, staticRenderFns } from "./OliverSalesStats.vue?vue&type=template&id=327d95e0"
import script from "./OliverSalesStats.vue?vue&type=script&lang=js"
export * from "./OliverSalesStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports